import HeartIcon from '~/images/icons/heart-tilted.svg';
import numeral from 'numeral';
import pluralize from 'pluralize';
import { observer } from 'mobx-react';

const AmountImpactCalculator = observer(
  ({
    amount,
    costPerPerson = 40,
    currencyUnit = '$',
    donationType,
    iconSize = '28px',
    imgClasses,
    pClasses,
    wrapperClasses,
  }) => {
    const formattedPeopleServed = (peopleServed) => `${numeral(peopleServed).format('0,0')} ${pluralize('person', peopleServed)}`;

    const peopleServedText = () => {
      const peopleServed = Math.floor(amount / costPerPerson);
      if (peopleServed === 0 || !amount) {
        return 'Your gift will serve people with clean water.';
      } else {
        return (
          <>
            A {currencyUnit}{amount} gift serves{' '}
            <span className='font-medium'>
              {formattedPeopleServed(peopleServed)}
            </span>{' '}
            with clean water.
          </>
        );
      }
    };

    const peopleServedYearlyText = () => {
      const peopleServedYearly = Math.floor((amount * 12) / costPerPerson);
      if (peopleServedYearly === 0 || !amount) {
        return 'Your monthly gift will serve people with clean water all year long.';
      } else {
        return (
          <>
            Gives{' '}
            <span className='font-medium'>
              {formattedPeopleServed(peopleServedYearly)}
            </span>{' '}
            clean water every year.
          </>
        );
      }
    };

    const impactCalculatorText = () => {
      switch (donationType) {
        case 'one-time':
          return peopleServedText();
        case 'monthly':
          return peopleServedYearlyText();
      }
    };

    return (
      <div className={wrapperClasses}>
        <img
          className={imgClasses}
          src={HeartIcon}
          style={{ height: iconSize, width: iconSize }}
        />
        <p className={pClasses}>{impactCalculatorText()}</p>
      </div>
    );
  }
);

export default AmountImpactCalculator;
